<template>
  <div id="app">
    <header id="site-header">
      <div class="container nav-wrapper">
        <div class="row">
          <div class="site-branding col-xs-12">
            <router-link :to="{name: 'MainPage'}">
              <img
                src="/static/img/guyana-live-logo.png"
                alt
              >
            </router-link>
          </div>
          <div
            id="site-navigation"
            class="col-lg-12"
          >
            <ul class="main-menu">
              <li>
                <router-link :to="{name: 'MainPage'}">Home</router-link>
              </li>
              <li>
                <router-link :to="{name: 'GalleryPage'}">Gallery</router-link>
              </li>
              <li>
                <router-link :to="{name: 'VideosPage'}">Videos</router-link>
              </li>
              <li class="logo-item">
                <router-link :to="{name: 'MainPage'}">
                  <img
                    src="/static/img/guyana-live-logo.png"
                    alt
                  >
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'EventsPage'}">Events</router-link>
              </li>
              <li>
                <router-link :to="{name: 'ContactPage'}">Contact</router-link>
              </li>
            </ul>
          </div>
          <div
            id="nav-toggle"
            class="menu-icon"
          ></div>
        </div>
      </div>
    </header>
    <router-view />
    <!-- footer -->
    <div id="footer">
      <div class="container">
        <div class="site-branding">
          <a href="index.html">
            <img
              src="/static/img/guyana-live-logo-footer.png"
              alt
            >
          </a>
        </div>
        <p>Copyright 2020 Guyana Live. All Rights Reserved.</p>
        <p style="font-size: 12px"><a style="color: white" href="https://policies.google.com/privacy?hl=en-US">Google Privacy Policy</a> | 
         <a style="color: white" href="https://www.youtube.com/static?template=terms">Youtube ToS</a>
        
        </p>
        <ul class="social-networks">
          <li>
            <a
              href="https://www.facebook.com/guyanalive/"
              target="_blank"
            >
              <img
                src="/static/icons/fb-min-yellow.png"
                alt="Facebook"
              >
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/guyanalive/"
              target="_blank"
            >
              <img
                src="/static/icons/instagram-min-yellow.png"
                alt="Instagram"
              >
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/guyanaliveent"
              target="_blank"
            >
              <img
                src="/static/icons/twitter_gold.png"
                alt="Twitter"
              >
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/user/GuyanaLive"
              target="_blank"
            >
              <img
                src="/static/icons/yt-min-yellow.png"
                alt="Youtube"
              >
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: null
    }
  },
  created() {
    let date = new Date();
    this.year = date.getFullYear();    
  }
}
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#site-header .nav-wrapper #site-navigation .main-menu li a {
  padding: 0px;
}
#site-header {
  text-align: center;
}
#footer {
  margin-top: 55px;
}
.breadcrumb a {
  color: whitesmoke;
}
.breadcrumb a:hover {
  color: #ff3019;
}
</style>



// WEBPACK FOOTER //
// src/App.vue